import Tag from '../Tag'
import * as S from './styles'

type Props = {
  id: number
  title: string
  category: string
  system: string
  description: string
  infos: string[]
  image: string
}

const Product = ({
  id,
  title,
  category,
  system,
  description,
  infos,
  image
}: Props) => {
  const getDescription = (text: string) => {
    if (text.length > 115) {
      return text.slice(0, 115) + '...'
    }
    return text
  }

  return (
    <S.Card to={`/product/${id}`}>
      <img src={image} alt={title} />
      <S.Infos>
        {infos.map((info) => (
          <Tag key={info}>{info}</Tag>
        ))}
      </S.Infos>
      <S.Title>{title}</S.Title>
      <Tag>{category}</Tag>
      <Tag>{system}</Tag>
      <S.Description>{getDescription(description)}</S.Description>
    </S.Card>
  )
}

export default Product
